'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Trigger, Value, Icon } from './../../../external/@radix-ui/react-select/dist/index.js';
import { useCallback } from 'react';
import { IconChevronDown } from '../../svg/icons/icon-chevron-down.js';
import { FontWeight } from '../../util/font.js';
import { Tooltip } from '../tooltip/tooltip.js';
import { BaseSelect } from './base-select.js';
import { getSelectStyles } from './constants.js';

const Select = ({ borderless, errorMessage, label, disabled, DisabledIcon, disabledTooltipContent, placeholder, options, value, onValueChange, fontWeight, }) => {
    const TriggerComponent = useCallback(({ id, value }) => {
        const disabledIcon = DisabledIcon ? (jsx(DisabledIcon, { className: "size-4" })) : null;
        const disabledIconWithTooltip = disabledIcon ? (disabledTooltipContent ? (jsx(Tooltip, { content: disabledTooltipContent, side: "top", children: disabledIcon })) : (disabledIcon)) : null;
        return (jsxs(Trigger, { id: id, className: `flex w-full items-center justify-between rounded-lg border-leland-gray-stroke bg-leland-white py-3 pl-4 pr-3 ${disabled
                ? 'text-leland-gray-extra-light'
                : 'text-leland-gray-dark'} ${borderless ? 'border-0' : 'border'} ${getSelectStyles({
                fontWeight: fontWeight ?? FontWeight.NORMAL,
            })}`, children: [jsxs("div", { className: "flex items-center gap-2", children: [value?.LeftIcon ? (jsx(value.LeftIcon, { className: "size-4 text-leland-gray-dark" })) : null, jsx(Value, { placeholder: jsx("span", { className: "text-leland-gray-extra-light", children: placeholder ?? 'Select an option' }) })] }), disabled ? (disabledIconWithTooltip) : (jsx(Icon, { children: jsx(IconChevronDown, { className: "size-4 text-leland-gray-dark" }) }))] }));
    }, [
        DisabledIcon,
        disabledTooltipContent,
        disabled,
        borderless,
        fontWeight,
        placeholder,
    ]);
    return (jsx(BaseSelect, { errorMessage: errorMessage, label: label, disabled: disabled, placeholder: placeholder, onValueChange: onValueChange, options: options, value: value, TriggerComponent: TriggerComponent, fontWeight: fontWeight }));
};

export { Select };
//# sourceMappingURL=select.js.map
